import type { accountAssignmentType_enum } from '@vrplatform/graphql';

export const formatAssignmentType = (
  assignmentType: accountAssignmentType_enum | undefined
) => {
  if (!assignmentType) return '';

  const titles: Record<accountAssignmentType_enum, string> = {
    deposit_merchantFee: 'Deposit Merchant Fee',
    deposit_coHostPayout: 'Deposit Co-Host Payout',
    deposit_vat: 'Deposit VAT',
    deferredRevenue: 'Deferred Revenue',
    accountsPayable: 'Accounts Payable',
    accountsReceivable: 'Accounts Receivable',
    expense_reimbursement: 'Expense Reimbursement',
    deposit_reserve: 'Deposit Reserve',
    deposit_channelFee: 'Deposit Channel Fee',
    expense_markup: 'Expense Markup',
    cancellationRevenue: 'Cancellation Revenue',
    payout_distribution: 'Payout Distribution',
    payout_bankAccount: 'Payout Bank Account',
    expense_salesTax: 'Expense Sales Tax',
    openingBalance: 'Opening Balance',
    dueToFromTrust: 'Due to/from Trust',
  };

  return titles[assignmentType] || assignmentType;
};
